import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { $POST } from "../../../api";
import { login } from "../../../store/slices/auth.slice";
import Router from "../../../const/router";
import "./index.scss";

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();

  const submitForm = useCallback(
    async (e) => {
      e.preventDefault();
      try {
        const { data } = await $POST(Router.LOGIN, {
          email,
          password,
        });
        dispatch(login());
        localStorage.setItem("token", data.token);
      } catch (err) {
        throw new Error(err.message);
      }
    },
    [email, password, dispatch]
  );

  return (
    <section className="login">
      <form className="login-form" onSubmit={submitForm}>
        <h1>Login</h1>
        <div className="login-form-fields">
          <input
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            type="text"
            placeholder="email"
          />
          <input
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            type="password"
            placeholder="passsword"
          />
        </div>
        <button>Login</button>
      </form>
      <div className="bg-filter"></div>
    </section>
  );
};

export default LoginForm;
